module.exports = __webpack_public_path__ + "img/b9e654c.png";